import { Action, Reducer } from 'redux';

export interface ServerPageState<P> {
	page: P | null;
	path: string | null;
	isLoading: boolean;
}

export enum TypeKeys {
	REQUESTPAGE = 'REQUESTPAGE',
	RECIEVEPAGE = 'RECIEVEPAGE'
}

export interface RequestServerPageAction {
	type: TypeKeys.REQUESTPAGE;
	storageName: string | null;
	path: string;
}

export interface ReceiveServerPageAction {
	type: TypeKeys.RECIEVEPAGE;
	storageName: string | null;
	page: any;
}

type KnownPageAction = RequestServerPageAction | ReceiveServerPageAction;

export const reducer = <P>(storageName: string): Reducer<ServerPageState<P>> => {
	return (state: ServerPageState<P> = { isLoading: false, page: null, path: '' }, incomingAction: Action) => {
		const action = incomingAction as KnownPageAction;
		if (!action.storageName || action.storageName === storageName) {
			switch (action.type) {
				case TypeKeys.REQUESTPAGE:

					return {
						isLoading: true,
						page: state.page,
						path: action.path,
					};
				case TypeKeys.RECIEVEPAGE:
					return { isLoading: false, page: action.page, path: action.page.path };
				default:
					const exhaustiveCheck: never = action;
			}
		}

		return state;
	};
};
